import { Script } from "../../../lib/api/models";
import StyledButton from "../../common/buttons/StyledButton";
import TextButton from "../../common/buttons/TextButton";
import ConversationScript from "../../common/ConversationScript";
import BaseModal from "../../common/modals/BaseModal/BaseModal";
import ModalCloseButton from "../../common/modals/ModalCloseButton/ModalCloseButton";
import styles from "./StopServiceConfirmationModal.module.css";

const strings = {
  yes: "Yes, Stop",
  cancel: "Cancel",
};

type Props = {
  isOpen: boolean;
  onSuccess: () => void;
  onRequestClose: () => void;
  title: string;
  scripts: Script[];
  scriptName?: string;
};

export default function StopServiceConfirmationModal({
  isOpen,
  onSuccess,
  onRequestClose,
  title,
  scriptName,
  scripts,
}: Props) {
  return (
    <BaseModal
      className={styles.modal}
      label={title}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        <ModalCloseButton onClick={onRequestClose} />
      </div>
      <div className={styles.body}>
        <ConversationScript scripts={scripts} scriptName={scriptName} />
      </div>
      <div className={styles.footer}>
        <StyledButton className={styles.okButton} onClick={onSuccess}>
          {strings.yes}
        </StyledButton>
        <TextButton onClick={onRequestClose}>{strings.cancel}</TextButton>
      </div>
    </BaseModal>
  );
}
